export default __webpack_public_path__ + "static/media/join.e30371e8.gif";